"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
var ui_tools_1 = require("@ovotech/ui-tools");
var react_1 = __importStar(require("react"));
var core_1 = require("../../../../shared/core");
var analytics_subjects_1 = require("../../analytics-subjects");
var Toggle_styled_1 = require("./Toggle.styled");
exports.Toggle = (0, react_1.forwardRef)(function (_a, ref) {
    var options = _a.options, value = _a.value, id = _a.id, onSelect = _a.onSelect, rest = __rest(_a, ["options", "value", "id", "onSelect"]);
    var SecondaryCTAButton = (0, core_1.useComponents)().SecondaryCTAButton;
    return (react_1.default.createElement(Toggle_styled_1.StyledToggleContainer, __assign({ ref: ref }, rest), options.map(function (_a) {
        var _b;
        var label = _a.label, oValue = _a.value, disabled = _a.disabled;
        return (react_1.default.createElement(ui_tools_1.AnalyticsClick, { key: "toggle-".concat(oValue), name: analytics_subjects_1.TOGGLE_FIELD_TOGGLE, properties: (_b = { value: oValue, id: id }, _b[core_1.INTERNAL_EVENT_FLAG] = true, _b) },
            react_1.default.createElement(Toggle_styled_1.StyledToggleButton, { as: SecondaryCTAButton, type: "button", "data-testid": "toggle-".concat(id, "-").concat(oValue), "aria-pressed": oValue === value, disabled: disabled, onClick: function () { return oValue !== value && onSelect && onSelect(oValue); }, fullWidth: "never" }, label)));
    })));
});
